export default __webpack_public_path__ + "static/media/hero-mobile.06e0b0f7.webp";